import React from 'react';
import ReactDOM from 'react-dom';

import App from './Components/App/App';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import 'bootstrap/dist/js/bootstrap.min.js';

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js